import HTTP from './HTTP.js';
import SymfonyErrorFormatter from './SymfonyErrorFormatter';

class OrderServices {
  static getOrders(filters, orderBy, cursor, currentPage, perPage) {
    return HTTP.get(`orders`, {
      params: {
        cursor: cursor,
        orderBy: orderBy,
        limit: perPage,
        filters: filters,
        include: 'agency',
        page: currentPage,
      },
    })
      .then((response) => {
        return {
          data: response.data.orders,
          meta: response.data.meta,
        };
      })
      .catch(() => {
        return Promise.reject('Could not get End Point');
      });
  }

  static getTotalRows(filters) {
    return HTTP.get(`orders/row-count`, {
      params: {
        filters: filters,
        include: 'agency',
      },
    })
      .then((response) => {
        return {
          data: response.data,
        };
      })
      .catch(() => {
        return Promise.reject('Could not get End Point');
      });
  }

  static updateInvoice(campaignId, isInvoiced) {
    return HTTP.post(`orders/invoice/${campaignId}`, {invoiced: isInvoiced})
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return SymfonyErrorFormatter.clean(error.response);
      });
  }

  static exportToCSV(filters, orderBy) {
    return HTTP.get(`orders/export`, {
      responseType: 'blob',
      params: {
        orderBy: orderBy,
        filters: filters,
        include: 'agency',
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(() => {
        return Promise.reject('Could not get End Point');
      });
  }

  static campaignExportToCSV(filters, orderBy) {
    return HTTP.get(`campaign-modified-reports`, {
      responseType: 'blob',
      params: {
        orderBy: orderBy,
        filters: filters,
        include: 'agency',
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(() => {
        return Promise.reject('Could not get End Point');
      });
  }

  static getOrdersByAgency(agency, cursor = 0, filters) {
    return HTTP.get(`orders/by-agency`, {
      params: {
        agency: agency,
        cursor,
        limit: 10,
        filters,
      },
    })
      .then((response) => {
        return {
          data: response.data.orders,
          meta: response.data.meta,
        };
      })
      .catch(() => {
        return Promise.reject('Could not get End Point');
      });
  }

  static signifiExportToCSV(filters, orderBy) {
    return HTTP.get(`orders/signifi`, {
      responseType: 'blob',
      params: {
        orderBy: orderBy,
        filters: filters,
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(() => {
        return Promise.reject('Could not get End Point');
      });
  }
}

export default OrderServices;
